import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

import Page from '../index';

import './styles.scss';


const Privacy = ({ pages }) => {
  const page = pages.privacy;
  return (
    <Page slug='privacy'>

      { page.policy === undefined ?
        <div styleName='privacy-policy'><p>Loading&hellip;</p></div>
      :
        <div
          styleName='privacy-policy'
          dangerouslySetInnerHTML={{ __html: page.policy ? page.policy.content || '' : '' }} // eslint-disable-line react/no-danger, max-len
        />
      }

    </Page>
  );
};

Privacy.propTypes = {
  pages: PropTypes.shape({
    privacy: PropTypes.shape({
      policy: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    }),
  }).isRequired,
};

const mapStateToProps = state => ({
  pages: state.pages.bySlug,
});

export default connect(
  mapStateToProps, {},
)(Privacy);



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/Page/Privacy/index.jsx